import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const AdkFeedTable = ({ feeds, partners, defaultOffers, onRemove, onUpdate, onSort }) => {
    const rows = feeds.map((feed, index) => <Row key={index} feed={feed} partners={partners} defaultOffers={defaultOffers} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('id')}>ID</th>
                    <th onClick={() => onSort('name')}>Name</th>
                    <th onClick={() => onSort('type')}>Type</th>
                    <th onClick={() => onSort('auth')}>Auth</th>
                    <th onClick={() => onSort('factor')}>Factor</th>
                    <th onClick={() => onSort('partnerId')}>Partner</th>
                    <th onClick={() => onSort('defaultOfferId')}>Default Offer</th>
                    <th onClick={() => onSort('zone')}>Zone</th>
                    <th onClick={() => onSort('device')}>Device</th>
                    <th onClick={() => onSort('roi')}>ROI</th>
                  <th onClick={() => onSort('cpm')}>CPM</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkFeedTable;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerFeeds/components/Table/index.js